<template>
  <div class="homecontainer _homecontainer">
    <img
        src="//cn.bing.com/th?id=OHR.PurpleCrocus_ZH-CN0891528297_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp"
        alt=""
        srcset=""
        class="backgroundPic"
    />

    <div style="position: relative; z-index: 99">
      <div
          style="
          background-color: rgb(240, 242, 245);
          width: 680px;
          margin: 0 auto;
        "
      >
        <div class="itemBox" style="text-align: center; padding: 20px 0">
          <div>
            <img src="../../assets/logo.png" alt="" srcset=""/>
          </div>
        </div>
        <div class="itemBox">
          <div class="title"><span class="title-icon"></span>站点公告</div>
          <div class="list-group-item">
            <span class="index" style="background-color: #d9534f">1</span
            ><span>售后问题可直接联系客服飞机@TGboxuan</span>
          </div>
          <div class="list-group-item">
            <span class="index" style="background-color: #5cb85c">2</span
            ><span>下单之前请一定要看完该商品的注意事项再进行下单！</span>
          </div>
          <div class="list-group-item">
            <span class="index" style="background-color: #5bc0de">3</span
            ><span>所有业务全部恢复，都可以正常下单，欢迎尝试</span>
          </div>
          <div class="list-group-item">
            <span class="index" style="background-color: #f0ad4e">4</span
            ><span
          >温馨提示：请勿重复下单哦！必须要等待前面任务订单完成才可以下单！</span
          >
          </div>
        </div>
        <div class="itemBox">
          <div class="title"><span class="title-icon"></span>自助下单</div>
          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="账号下单" name="1">
              <div style="padding: 0 15px">
                <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-width="0px"
                    label-position="top"
                >
                  <el-form-item label="购买的商品" prop="goodsSkuId">
                    <el-select
                        style="width: 100%"
                        v-model="form.goodsSkuId"
                        placeholder="请选择您要购买的商品"
                        size="mini"
                        @change="handleGoodsSkuSelectChange"
                    >
                      <el-option
                          v-for="item in goodsList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="skuRemainQuantity">
                    <span>剩余库存：{{ skuRemainQuantity }}</span>
                  </el-form-item>
                  <el-form-item v-if="skuDescription">
                    <p>{{ skuDescription }}</p>
                  </el-form-item>
                  <el-form-item label="商品数量" prop="quantity">
                    <el-input-number
                        v-model="form.quantity"
                        placeholder="请输入商品数量"
                        :controls="false"
                        :min="1"
                        style="width: 100%"
                        size="mini"
                    />
                  </el-form-item>
                  <el-form-item label="联系方式" prop="contactInfo">
                    <el-input
                        v-model="form.contactInfo"
                        placeholder="飞机(TG)号，请牢记；长度需在6至20位之间"
                        :maxlength="20"
                        size="mini"
                    />
                  </el-form-item>
                  <el-form-item label="取卡密码" prop="extractionPwd">
                    <el-input
                        v-model="form.extractionPwd"
                        placeholder="请牢记，长度需在6至20位之间"
                        :maxlength="20"
                        size="mini"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item label="支付方式" prop="payMethod">
                    <el-select
                        style="width: 100%"
                        v-model="form.payMethod"
                        placeholder="请选择支付方式"
                        size="mini"
                    >
                      <el-option
                          v-for="item in payTypeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <div style="text-align: center; margin: 20px 0">
                    <el-button
                        type="primary"
                        @click="submitForm('form')"
                        size="mini"
                    >立即下单
                    </el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>

            <el-tab-pane label="数据下单" name="2">
              <div style="padding: 0 15px">
                <el-form
                    ref="form2"
                    :model="form"
                    :rules="rules"
                    label-width="0px"
                    label-position="top"
                >
                  <el-form-item label="购买的商品" prop="goodsSkuId">
                    <el-select
                        style="width: 100%"
                        v-model="form.goodsSkuId"
                        placeholder="请选择您要购买的商品"
                        size="mini"
                        @change="handleGoodsSkuSelectChange"
                    >
                      <el-option
                          v-for="item in goodsList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model="duplicateCheckEnabled">上传文件，去除重复库存</el-checkbox>
                    <el-upload
                        v-if="duplicateCheckEnabled"
                        ref="duplicateCheckFileUploader"
                        accept=".txt"
                        :action="duplicateCheckFileUploadApiUrl"
                        :data="duplicateCheckFileUploadApiData"
                        :file-list="duplicateCheckFileList"
                        :auto-upload="false"
                        :multiple="false"
                        :limit="1"
                        :on-success="handleDuplicateCheckFileUploadSuccess"
                        :on-error="handleDuplicateCheckFileUploadError"
                    >
                      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                      <el-button style="margin-left: 10px;" size="small" type="success"
                                 @click="handleDuplicateCheckFileUploadSubmit">查询去重后库存</el-button>
                      <div slot="tip" class="el-upload__tip upload-tip">
                        <p>只能上传txt文件，不能接受excel；请所有数据汇总一个文档中，再去重；超过30万行数据，请联系飞机@TGboxuan</p>
                      </div>
                    </el-upload>
                  </el-form-item>
                  <el-form-item v-if="skuRemainQuantity">
                    <span>剩余库存：{{ skuRemainQuantity }}</span>
                  </el-form-item>
                  <el-form-item v-if="skuDescription">
                    <p>{{ skuDescription }}</p>
                  </el-form-item>
                  <el-form-item label="商品数量" prop="quantity">
                    <el-input-number
                        v-model="form.quantity"
                        placeholder="请输入商品数量"
                        :controls="false"
                        :min="1"
                        style="width: 100%"
                        size="mini"
                    />
                  </el-form-item>
                  <el-form-item label="联系方式" prop="contactInfo">
                    <el-input
                        v-model="form.contactInfo"
                        placeholder="飞机(TG)号，请牢记；长度需在6至20位之间"
                        :maxlength="20"
                        size="mini"
                    />
                  </el-form-item>
                  <el-form-item label="取卡密码" prop="extractionPwd">
                    <el-input
                        v-model="form.extractionPwd"
                        placeholder="请牢记，长度需在6至20位之间"
                        :maxlength="20"
                        size="mini"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item label="支付方式" prop="payMethod">
                    <el-select
                        style="width: 100%"
                        v-model="form.payMethod"
                        placeholder="请选择支付方式"
                        size="mini"
                    >
                      <el-option
                          v-for="item in payTypeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <div style="text-align: center; margin: 20px 0">
                    <el-button
                        type="primary"
                        @click="submitForm('form2')"
                        size="mini"
                    >立即下单
                    </el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>

            <!-- 查单页 -->
            <el-tab-pane label="查单" name="searchForm">
              <div style="padding: 0 15px">
                <el-form
                    ref="searchForm"
                    :model="searchForm"
                    :rules="searchFormRules"
                    label-width="100px"
                    label-position="top"
                >
                  <el-form-item label="订单号" prop="buyerInfo">
                    <span class="text-danger">（请记下订单号，取号后作废）</span>
                    <el-input
                        v-model="searchForm.buyerInfo"
                        placeholder="请输入订单号"
                        size="mini"
                    />
                  </el-form-item>
                  <el-form-item label="取卡密码" prop="extractionPwd">
                    <el-input
                        v-model="searchForm.extractionPwd"
                        placeholder="请输入取卡密码"
                        :minlength="6"
                        :maxlength="20"
                        size="mini"
                    >
                    </el-input>
                  </el-form-item>
                  <div style="text-align: center; margin: 20px 0">
                    <el-button
                        type="primary"
                        @click="submitForm('searchForm')"
                        size="mini"
                    >立即查询
                    </el-button>
                  </div>
                </el-form>
                <el-descriptions
                    class="margin-top"
                    title=""
                    :column="1"
                    size="small"
                    border
                    style="margin: 20px 0"
                    v-if="searchOrderShow"
                >
                  <el-descriptions-item labelStyle="width:160px;">
                    <template slot="label"> 订单号</template>
                    {{ order.outTradeNo }}
                  </el-descriptions-item>
                  <el-descriptions-item labelStyle="width:160px;">
                    <template slot="label"> 购买的商品</template>
                    {{ order.buyGoodsSkuFull }}
                  </el-descriptions-item>
                  <el-descriptions-item labelStyle="width:160px;">
                    <template slot="label"> 数据行数</template>
                    {{ order.actualQuantity }}
                  </el-descriptions-item>
                  <el-descriptions-item labelStyle="width:160px;">
                    <template slot="label"> 操作</template>
                    <el-button type="primary" @click="handleDown()" size="mini">提取</el-button>
                    <el-button size="mini" @click="handleDownloadAsTxt()" v-if="extractionFulltext">下载为TXT</el-button>
                  </el-descriptions-item>

                  <br />
                  <el-descriptions-item label="数据" v-if="extractionFulltext">
                    <pre>{{ extractionFulltext }}</pre>
                  </el-descriptions-item>
                  <el-descriptions-item label="下载地址" v-if="extractionUrl">
                    <a :href="extractionUrl" target="_blank">{{ extractionUrl }}</a>
                    <p>直接左键单击；或右键选择【链接另存为】</p>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <!-- 收银台模态框 -->
    <el-dialog
        title="订单信息"
        :visible.sync="checkoutDialogVisible"
        width="960px"
        top="3vh"
        center
        :close-on-click-modal="false"
    >
      <el-descriptions
          class="margin-top"
          title=""
          :column="1"
          size="small"
          border
          style="margin: 20px 0"
      >
        <el-descriptions-item labelStyle="width:160px">
          <template slot="label">购买的商品</template>
          <span class="text-bigger">{{ order.buyGoodsSkuFull }}</span>
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:400px; font-size: 16px; color: red;">
          <template slot="label">订单号(请记下订单号，取号后作废)</template>
          <span class="text-danger">{{ order.outTradeNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:400px; font-size: 14px; color: red;">
          <template slot="label">您的联系方式(请牢记)</template>
          <span class="text-bigger">{{ form.contactInfo }}</span>
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:400px; font-size: 14px; color: red;">
          <template slot="label">取卡密码(请牢记)</template>
          <span class="text-bigger">{{ form.extractionPwd }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <div>
        {{ `请在${order.timeout}分钟内付款(截止时间: ${order.expiredAt})` }}
      </div>
      <el-descriptions
          class="margin-top"
          title=""
          :column="1"
          size="small"
          border
          style="margin: 20px 0"
      >
        <el-descriptions-item>
          <p class="text-bigger">请扫描二维码选择USDT或者手动复制本地址完成交易</p>
          <p class="text-bigger">（仅支持链上交易，不支持交易所内部交易）</p>
        </el-descriptions-item>
        <el-descriptions-item label-style="width: 160px;">
          <template slot="label">交易地址</template>
          <p class="text-danger">{{ order.payTokenToAddress }}</p>
        </el-descriptions-item>
        <el-descriptions-item label="二维码">
          <img src="../../assets/usdt-to-address.png"  alt="" style="height: 220px;"/>
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width: 0;">
          <span class="text-bigger">需转账金额：</span>
          <span class="text-danger">{{ order.actualAmountTotal + ' ' + order.payMethodLabel }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <p class="text-danger">转账数量包括小数点一定不要转多或者转少，转错即无法自动发卡，售后联系飞机@TGboxuan</p>
        </el-descriptions-item>
      </el-descriptions>
      <div style="text-align: center">
        <el-button type="primary" @click="handleGoSearch()" size="mini"
        >我已转账
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getGoodsList, searchOrderApi, downApi, buyApi} from '@/api/http.js'
import {defHttpCatch} from '../../utils/request'
import {duplicateCheckFileUploadApiUrl, getAnnouncementText} from '../../api/http'

export default {
  name: '',
  components: {},
  data () {
    return {
      activeName: '1',
      /*
      -- 下单
       */
      form: {
        goodsSkuId: null,
        quantity: 1,
        payMethod: 2,
        checkLogId: null
      },
      goodsList: null,
      skuDescription: null,
      skuRemainQuantity: null,
      payTypeList: [
        {
          value: 2,
          label: 'USDT'
        }
      ],
      extractionFulltext: null,
      extractionUrl: null,
      rules: {
        quantity: [
          {required: true, message: '请输入商品数量', trigger: 'blur'}
        ],
        contactInfo: [
          {
            required: true,
            message: '请输入飞机(TG)号',
            trigger: 'blur'
          },
          {min: 6, max: 20, message: '长度需在6至20位', trigger: 'blur'}
        ],
        goodsSkuId: [
          {
            required: true,
            message: '请选择您要购买的商品',
            trigger: 'change'
          }
        ],
        payMethod: [
          {
            required: true,
            message: '请选择支付方式',
            trigger: 'change'
          }
        ],
        extractionPwd: [
          {required: true, message: '请输入取卡密码', trigger: 'blur'},
          {min: 6, max: 20, message: '长度需在6至20位', trigger: 'blur'}
        ]
      },
      // 库存去重相关
      duplicateCheckEnabled: false,
      duplicateCheckFileUploadApiUrl: duplicateCheckFileUploadApiUrl,
      duplicateCheckFileUploadApiData: {
        classified: 'duplicate-check-file'
      },
      duplicateCheckFileList: [],
      /*
      -- 查单
       */
      searchFormRules: {
        buyerInfo: [
          {required: true, message: '请输入订单号', trigger: 'blur'}
        ],
        extractionPwd: [
          {required: true, message: '请输入取卡密码', trigger: 'blur'},
          {min: 6, max: 20, message: '长度在6到20个字符', trigger: 'blur'}
        ]
      },
      searchForm: {},
      searchOrderShow: false,
      order: {},
      checkoutDialogVisible: false
    }
  },
  methods: {
    open () {
      getAnnouncementText()
        .then((res) => {
          this.$alert(res.data,
            '',
            {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true
            }
          )
        })
        .catch((err) => {
          defHttpCatch(this, err)
        })
      /*
      `
博轩脚本，坚持以用户体验为先
<br /><br />如有疑问，在线客服随叫随到
<br /><br />建议联系在线客服  飞机@TGboxuan
`
       */
    },
    handleTabClick (tab, event) {
      // 重置表单
      this.form = {
        goodsSkuId: null,
        quantity: 1,
        payMethod: 2,
        checkLogId: null
      }
      this.skuDescription = null
      this.skuRemainQuantity = null

      // 重新拉取商品列表
      this.getGoods()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
          })
          if (formName === 'searchForm') {
            // 查单页
            searchOrderApi(this.searchForm)
              .then((res) => {
                loading.close()
                this.order = res.data
                this.searchOrderShow = true
              })
              .catch((err) => {
                defHttpCatch(this, err)
                loading.close()
              })
          } else {
            buyApi(this.form)
              .then((res) => {
                loading.close()
                this.order = res.data
                this.checkoutDialogVisible = true
                this.searchForm = {
                  buyerInfo: res.data.outTradeNo,
                  extractionPwd: this.form.extractionPwd
                }
              })
              .catch((err) => {
                defHttpCatch(this, err)
                loading.close()
              })
          }
        }
      })
    },
    handleDown () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      downApi({
        accessToken: this.order.accessToken,
        outTradeNo: this.order.outTradeNo
      })
        .then((res) => {
          loading.close()
          if (res.data.url) {
            // 打开新页面下载
            // window.open(res.data.url)
            this.extractionUrl = res.data.url
          } else {
            // console.log('downApi.then.else >> res.data', res.data)
            this.extractionFulltext = res.data.fulltext
          }
        })
        .catch((err) => {
          defHttpCatch(this, err)
          loading.close()
        })
    },
    handleGoSearch () {
      const self = this
      self.$alert(`
       <p class="text-bigger">因区块链同步机制，转账后可能需要1~10分钟，才能确认到转账成功完成</p>
       <br />
    <p class="text-bigger">请您耐心等待，如果遇到问题，提供订单号、联系方式、取卡密码等信息联系客服飞机@TGboxuan</p>
  `, {
        dangerouslyUseHTMLString: true
      }).then(
        (ret) => {
          self.activeName = 'searchForm'
          self.resetSearchForm()
        }
      )
    },
    getGoods () {
      this.goodsList = [{
        value: 0,
        label: '加载中……如果长时间未加载出列表，请直接刷新页面重试'
      }]

      let classified = this.activeName
      if (/^\d+$/.test(classified)) {
        // 数字才作为类别，请求商品
        getGoodsList(classified)
          .then((res) => {
            this.goodsList = res.data.map((item) => {
              return {
              // 控件必需字段
                value: item.id,
                label: item.title,
                // 自定义业务字段
                description: item.description,
                remainStockQuantity: item.remainStockQuantity
              }
            })
          })
          .catch((err) => {
            defHttpCatch(this, err)
          })
      }
    },
    handleGoodsSkuSelectChange (selectedValue) {
      this.skuDescription = null
      this.skuRemainQuantity = null
      for (let item of this.goodsList) {
        // console.log('item.value', item.value, typeof item.value)
        // console.log('goodsSkuId', selectedValue, typeof selectedValue)
        if (item.value === selectedValue) {
          this.skuDescription = item.description
          this.skuRemainQuantity = item.remainStockQuantity
          break
        }
      }
    },
    handleDownloadAsTxt () {
      const fileinfo = {
        blobData: this.extractionFulltext,
        fileName: this.order.buyGoodsSkuFull + '.txt'
      }

      const tmpLink = document.createElement('a')
      const { blobData, fileName } = fileinfo
      const blob = new Blob([blobData], {
        type:
          'application/octet-stream'
      })
      const objectUrl = URL.createObjectURL(blob)
      tmpLink.href = objectUrl
      tmpLink.download = fileName

      document.body.appendChild(tmpLink) // 如果不需要显示下载链接可以不需要这行代码
      tmpLink.click()
      URL.revokeObjectURL(objectUrl)
    },
    /*
    库存去重相关
     */
    handleDuplicateCheckFileUploadSubmit () {
      const uploader = this.$refs.duplicateCheckFileUploader
      if (uploader.uploadFiles.length < 1) {
        this.$message.error('请先选择一个文件')
        return
      }

      const skuId = this.form.goodsSkuId
      if (!skuId) {
        this.$message.error('请先选择一款商品后再查询')
        return
      }
      this.duplicateCheckFileUploadApiData['skuId'] = skuId
      uploader.submit()
    },
    handleDuplicateCheckFileUploadSuccess (response, file, fileList) {
      this.skuRemainQuantity = response.data.remainStockQuantity
      this.form.checkLogId = response.data.checkLogId
    },
    handleDuplicateCheckFileUploadError (err, file, fileList) {
      this.$message.error(JSON.parse(err.message).msg)
    },
    resetSearchForm () {
      this.searchForm = {}
      this.searchOrderShow = false
      this.order = {}
      this.checkoutDialogVisible = false
    }
  },

  mounted () {
    this.open()
    this.getGoods()
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-input-number .el-input__inner {
  text-align: left !important;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: 0px !important;
}

/deep/ .el-form-item {
  margin-bottom: 10px;
}

/deep/ .el-form-item__label {
  line-height: 26px;
}

/deep/ .el-dialog__body {
  padding: 30px 20px;
  padding-top: 0 !important;
}

/deep/ .el-upload-list__item-status-label:after {
  content: ' 去重完成';
  color: red;
}

/deep/ .el-upload-list .el-progress__text:before {
  content: '去重中 ';
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  line-height: 38px;
  height: 38px;
  width: 100%;
  background-color: #64b2ca;
  display: inline-block;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding-left: 20px;
  // .title-icon {
  //   border-left: 4px solid rgb(51, 51, 51);
  //   border-radius: 3px;
  //   height: 15px;
  //   width: 4px;
  //   display: inline-block;
  //   margin-right: 10px;
  // }
}

.backgroundPic {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
}

.itemBox {
  border-radius: 5px;
  border: 1px solid #ffffff;
  background-color: #ffffff;
  padding: 0px;
  margin: 20px auto;
  width: 680px;
  // padding-bottom: 15px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
  font-size: 14px;

  .index {
    padding: 2px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
    color: #fff;
    margin-right: 15px;
  }
}

.text-bigger {
  font-size: 18px;
  font-weight: bold;
}

.text-danger {
  font-size: 26px;
  color: red;
}

.upload-tip {
  font-size: 15px;
  font-weight: bold;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue